"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.haulerManagerReducer = exports.haulerManagerAction = exports.haulerManagerTypes = void 0;
const hauler_manager_component_1 = __importDefault(require("./sub-components/hauler-manager.component"));
const hauler_manager_action_1 = __importDefault(require("./hauler-manager.action"));
exports.haulerManagerAction = hauler_manager_action_1.default;
const hauler_manager_reducer_1 = __importDefault(require("./hauler-manager.reducer"));
exports.haulerManagerReducer = hauler_manager_reducer_1.default;
const hauler_manager_types_1 = require("./hauler-manager.types");
Object.defineProperty(exports, "haulerManagerTypes", { enumerable: true, get: function () { return hauler_manager_types_1.haulerManagerTypes; } });
exports.default = hauler_manager_component_1.default;
